import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentNav: "index",
    // baseUrl: "http://192.168.3.187:8088", // 本地
    // fileUrlHeader: "http://192.168.0.231:8081", // 本地
    // baseUrl: "http://119.23.184.111", // 线上
    // fileUrlHeader:'http://119.23.184.111',  // 线上
    baseUrl: "", // 线上
    fileUrlHeader: "", // 线上
  },
  mutations: {
    updateCurrentNav(state, val) {
      state.currentNav = val;
    },
  },
  actions: {},
  modules: {},
});
